export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "cn",
    "resource": {
      "hi": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["kuboard"])}
    }
  })
}